import { render, staticRenderFns } from "./AboutFabres.vue?vue&type=template&id=a881b1dc&"
import script from "./AboutFabres.vue?vue&type=script&lang=js&"
export * from "./AboutFabres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports